import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import client from './client'
import { useAuthStore } from '../store/authStore'

export function useLogin() {
  const login = useAuthStore((s) => s.login)
  return useMutation({
    mutationFn: ({ email, password }) =>
      client.post('/api/auth/login', { email, password }).then((r) => r.data),
    onSuccess: (data) => login(data.user ?? data),
  })
}

export function useRegister() {
  const login = useAuthStore((s) => s.login)
  return useMutation({
    mutationFn: ({ username, email, password }) =>
      client.post('/api/auth/register', { username, email, password }).then((r) => r.data),
    onSuccess: (data) => login(data.user ?? data),
  })
}

export function useLogout() {
  const qc = useQueryClient()
  const logout = useAuthStore((s) => s.logout)
  return useMutation({
    mutationFn: () => client.post('/api/auth/logout'),
    onSettled: () => {
      logout()
      qc.clear()
    },
  })
}

export function useUpdateProfile() {
  const setUser = useAuthStore((s) => s.setUser)
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data) => client.patch('/api/user/profile', data).then((r) => r.data),
    onSuccess: (data) => {
      setUser(data)
      qc.invalidateQueries({ queryKey: ['me'] })
    },
  })
}

export function useUploadAvatar() {
  const setUser = useAuthStore((s) => s.setUser)
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (file) => {
      const form = new FormData()
      form.append('file', file)
      return client.post('/api/user/avatar', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then((r) => r.data)
    },
    onSuccess: (data) => {
      setUser(data)
      qc.invalidateQueries({ queryKey: ['me'] })
    },
  })
}

export function useDeleteAccount() {
  const qc = useQueryClient()
  const logout = useAuthStore((s) => s.logout)
  return useMutation({
    mutationFn: () => client.delete('/api/user/account'),
    onSuccess: () => { logout(); qc.clear() },
  })
}

export function useChangePassword() {
  return useMutation({
    mutationFn: (data) => client.patch('/api/user/password', data),
  })
}

export function useForgotPassword() {
  return useMutation({
    mutationFn: ({ email }) =>
      client.post('/api/auth/forgot-password', { email }).then((r) => r.data),
  })
}

export function useResetPassword() {
  return useMutation({
    mutationFn: ({ token, new_password }) =>
      client.post('/api/auth/reset-password', { token, new_password }).then((r) => r.data),
  })
}
